<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            About CEO
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/news-main/aboutceo-bannerimg.gif" alt="Manager"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Shares Kube G’s vision behind building a technology-driven enterprise.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Explains Kalpita Technologies’ journey and global growth strategy.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Highlights focus on digital transformation and innovation.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Emphasizes customer-centric service delivery.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Showcases leadership focus on culture, talent, and partnerships.</p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Founder Vision – </strong>Built to bridge the gap between business and technology.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Growth Journey – </strong>Scaled from startup to global IT services company.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Service Excellence – </strong>Strong focus on cloud, analytics, and engineering.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Differentiation – </strong>Agile delivery, R&D investment, and partnerships.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>People-First Culture – </strong>Employee well-being and learning drive innovation.</p>
      </div>
    </div>
    <a href="https://www.qnaindia.com/empowering-digital-transformation-in-a-conversation-with-kube-g-co-founder-ceo-kalpita-technologies/"
      target="_blank" class="btn case-study-btn">
      Read Full Article
    </a>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-newsarticle></app-relevant-newsarticle>